export const en = {
  setupHere: 'Setup here',
  info: 'Learn more',
  loadingIntegration: 'Loading integration'
};

export type Translations = typeof en;
